import { TicketQuota, TicketQuotaMessage } from '../../models';

export class DisplayTicketQuotaMessage {
	date: string
	comment: string
	pos: number
	actions: { [key: string]: number; }

	public static fromTQM(tqm: TicketQuotaMessage): DisplayTicketQuotaMessage {
		let dtqm: DisplayTicketQuotaMessage =  {
			date: tqm.date,
			comment: tqm.comment,
			pos: tqm.pos,
			actions: {}
		}

		tqm.actions.forEach(tqmAction => {
			if (tqmAction.type === ".AddToTicketQuotaAction") {
				dtqm.actions[tqmAction.bulkTicket.category.uuid] = tqmAction.bulkTicket.numberOfTickets
			} else if (tqmAction.type === ".RemoveFromTicketQuotaAction") {
				dtqm.actions[tqmAction.bulkTicket.category.uuid] = tqmAction.bulkTicket.numberOfTickets * -1
			} else if (tqmAction.type === ".AddVisualTicketsAction") {
				dtqm.actions[tqmAction.category.uuid] = tqmAction.seatTickets.length
			} else if (tqmAction.type === ".RemoveVisualTicketsAction") {
				dtqm.actions[tqmAction.category.uuid] = tqmAction.seatTickets.length * -1
			} else if (tqmAction.type === ".AddVisualBulkTicketsAction") {
				let numberOfTickets = 0
				tqmAction.visualBulkTickets.forEach(visualBulkTicket => numberOfTickets += visualBulkTicket.numberOfTickets)
				dtqm.actions[tqmAction.category.uuid] = numberOfTickets
			} else if (tqmAction.type === ".RemoveVisualBulkTicketQuotaAction") {
				let numberOfTickets = 0
				tqmAction.visualBulkTickets.forEach(visualBulkTicket => numberOfTickets += visualBulkTicket.numberOfTickets)
				dtqm.actions[tqmAction.category.uuid] = numberOfTickets * -1
			}
		})

		return dtqm
	}
}



// WEBPACK FOOTER //
// ./src/app/models/ui/display-ticket-quota-message.ui-model.ts